export default __webpack_public_path__ + "static/media/success_msg_icon.ed13129b.svg";